import { FormattedMessage } from 'react-intl'
import { calculateDiscountPercent } from 'utils'

const LabelText = ({ promotion, price, compareAtPrice }) => {
  if(promotion.kind === 10) {
    return (
      <span className='label-text'>
        {calculateDiscountPercent(price, compareAtPrice)}%
      </span>
    )
  } else if(promotion.kind === 20) {
    return <span className='label-text'>{promotion.value}%</span>
  } else if(promotion.kind === 30) {
    return (
      <span className='label-text free-nights'>
        <FormattedMessage
          values={{ qty: promotion.value }}
          id='night_qty'
          defaultMessage='{qty, plural, one {# night} other {# nights}}'
        />
      </span>
    )
  } else if(promotion.kind === 40) {
    return (
      <span className='label-text'>
        <FormattedMessage id='gift' defaultMessage='Gift' />
      </span>
    )
  }

  return null
}

export default function PromotionCornerLabel({
  promotion,
  price,
  compareAtPrice,
}) {
  if(!promotion) {
    return null
  }
  return (
    <span className='label-corner'>
      <LabelText
        promotion={promotion}
        price={price}
        compareAtPrice={compareAtPrice}
      />
      <span className='details'>
        <FormattedMessage id='details' defaultMessage='Details' />
      </span>
      <div className='description-promo'>
        <p>{promotion.title}</p>
        <div dangerouslySetInnerHTML={{ __html: promotion.description }} />
      </div>
    </span>
  )
}
